import gql from 'graphql-tag';
import { CountryFragment } from '../fragments/country.fragment';

export const SET_DEFAULT_COUNTRY = gql`
    mutation(
        $id: String!
    ) {
        countrySetDefault (id: $id) {
            ...CountryInfo
        }
    }
    ${CountryFragment}
`;